import React from 'react';
import {
  FaLaptopCode,
  FaMobileAlt,
  FaCloud,
  FaRobot,
  FaCogs,
  FaPalette,
  FaServer,
  FaChartLine,
  FaShieldAlt,
  FaNetworkWired,
  FaDatabase,
} from "react-icons/fa";

import './ShortServicesOverview.css';

export default function ShortServicesOverview() {
  return (
    <section className="services-overview">
      <div className="container">

        {/* Section Header */}
        <div className="section-header">
          <h2>Our Services</h2>
          <p>
            Empowering businesses with cutting-edge technology solutions. From enterprise software to AI, cloud, mobile, and industrial automation, we deliver services that drive growth, efficiency, and innovation.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">

          <div className="service-card">
            <div className="icon-container"><FaLaptopCode /></div>
            <h3>Enterprise Software Development</h3>
            <p>Custom, scalable, and secure software solutions designed to optimize business operations and drive growth.</p>
          </div>

          <div className="service-card">
            <div className="icon-container"><FaLaptopCode /></div>
            <h3>Web Application Development</h3>
            <p>Responsive, modern web apps built with React, Next.js, and MERN stack.</p>
          </div>

          <div className="service-card">
            <div className="icon-container"><FaMobileAlt /></div>
            <h3>Mobile Application Development</h3>
            <p>Native and cross-platform Android & iOS apps with excellent UX.</p>
          </div>

          <div className="service-card">
            <div className="icon-container"><FaCloud /></div>
            <h3>Cloud Solutions & SaaS Platforms</h3>
            <p>Cloud migration and SaaS platforms built for scalability.</p>
          </div>

          <div className="service-card">
            <div className="icon-container"><FaRobot /></div>
            <h3>AI & Machine Learning</h3>
            <p>Predictive analytics and intelligent automation using AI.</p>
          </div>

          <div className="service-card">
            <div className="icon-container"><FaCogs /></div>
            <h3>Industrial Automation & IoT</h3>
            <p>Smart automation and IoT solutions for modern industries.</p>
          </div>

          <div className="service-card">
            <div className="icon-container"><FaPalette /></div>
            <h3>UI/UX Design</h3>
            <p>Clean, intuitive, and user-focused interface design.</p>
          </div>

          <div className="service-card">
            <div className="icon-container"><FaServer /></div>
            <h3>DevOps & CI/CD</h3>
            <p>Containerized infrastructure and CI/CD pipelines.</p>
          </div>

          <div className="service-card">
            <div className="icon-container"><FaChartLine /></div>
            <h3>Data Analytics & BI</h3>
            <p>Dashboards and insights for data-driven decisions.</p>
          </div>

          <div className="service-card">
            <div className="icon-container"><FaShieldAlt /></div>
            <h3>Cybersecurity</h3>
            <p>Secure systems with compliance-ready architecture.</p>
          </div>

          <div className="service-card">
            <div className="icon-container"><FaNetworkWired /></div>
            <h3>Network & Infrastructure</h3>
            <p>Reliable networking and IT infrastructure solutions.</p>
          </div>

          <div className="service-card">
            <div className="icon-container"><FaDatabase /></div>
            <h3>Database & Storage</h3>
            <p>Scalable, high-performance database solutions.</p>
          </div>

        </div>
      </div>
    </section>
  );
}
